import React from 'react';
import { Link } from 'react-router-dom';
import styles from '../css/home.module.css';
import waves from '../img/background.svg';

const AnatomageHome = () => {
  return (
    <div className={styles.wrapper}>
      <div 
        className={styles.backgroundSvg}
        style={{ backgroundImage: `url(${waves})` }}
      />
      
      <div className={styles.container}>
        <div className={styles.header}>
          <h1>🎯 Table AI Platform</h1>
          <p>Choose your tool to get started</p>
        </div>

        <div className={styles.cardsSection}>
          <Link to="/anatomage/presets-creator/" className={styles.card}>
            <div className={styles.cardIcon}>🧠</div>
            <h2 className={styles.cardTitle}>AI Presets Creator</h2>
            <p className={styles.cardDescription}>
              Simplified Presets Creation System
            </p>
            <div className={styles.cardArrow}>→</div>
          </Link>

          <Link to="/anatomage/clinical-cases/" className={styles.card}>
            <div className={styles.cardIcon}>🏥</div>
            <h2 className={styles.cardTitle}>Case Library Searcher</h2>
            <p className={styles.cardDescription}>
              Simplified Medical Cases Search System
            </p>
            <div className={styles.cardArrow}>→</div>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default AnatomageHome;
